export const RESET_ERROR = 'insurances/RESET_ERROR';

export const FETCH_INSURANCE_COMPANIES_SUCCESS = 'insurances/FETCH_INSURANCE_COMPANIES_SUCCESS';
export const FETCH_INSURANCE_COMPANIES_FAIL = 'insurances/FETCH_INSURANCE_COMPANIES_FAIL';
export const FETCH_INSURANCE_COMPANY_SUCCESS = 'insurances/FETCH_INSURANCE_COMPANY_SUCCESS';
export const FETCH_INSURANCE_COMPANY_FAIL = 'insurances/FETCH_INSURANCE_COMPANY_FAIL';

export const FETCH_CONFIRMATION_NEW_SUCCESS = 'insurances/FETCH_CONFIRMATION_NEW_SUCCESS';
export const FETCH_CONFIRMATION_NEW_FAIL = 'insurances/FETCH_CONFIRMATION_NEW_FAIL';
export const FETCH_CONFIRMATION_DELETED_SUCCESS = 'insurances/FETCH_CONFIRMATION_DELETED_SUCCESS';
export const FETCH_CONFIRMATION_DELETED_FAIL = 'insurances/FETCH_CONFIRMATION_DELETED_FAIL';
export const FETCH_CONFIRMATION_CHANGED_SUCCESS = 'insurances/FETCH_CONFIRMATION_CHANGED_SUCCESS';
export const FETCH_CONFIRMATION_CHANGED_FAIL = 'insurances/FETCH_CONFIRMATION_CHANGED_FAIL';
export const SET_CONFIRMATION_DELETED_ROW = 'insurances/SET_CONFIRMATION_DELETED_ROW';

export const COPY_CONFIRMATION_SUCCESS = 'insurances/COPY_CONFIRMATION_SUCCESS';
export const COPY_CONFIRMATION_FAIL = 'insurances/COPY_CONFIRMATION_FAIL';

export const FETCH_VEHICLE_INSURANCE_POLICIES_SUCCESS = 'insurances/FETCH_VEHICLE_INSURANCE_POLICIES_SUCCESS';
export const FETCH_VEHICLE_INSURANCE_POLICIES_FAIL = 'insurances/FETCH_VEHICLE_INSURANCE_POLICIES_FAIL';
export const CREATE_VEHICLE_INSURANCE_POLICY_SUCCESS = 'insurances/CREATE_VEHICLE_INSURANCE_POLICY_SUCCESS';
export const CREATE_VEHICLE_INSURANCE_POLICY_FAIL = 'insurances/CREATE_VEHICLE_INSURANCE_POLICY_FAIL';
export const UPDATE_VEHICLE_INSURANCE_POLICY_SUCCESS = 'insurances/UPDATE_VEHICLE_INSURANCE_POLICY_SUCCESS';
export const UPDATE_VEHICLE_INSURANCE_POLICY_FAIL = 'insurances/UPDATE_VEHICLE_INSURANCE_POLICY_FAIL';
